<template>
  <div>
    <a-dropdown v-if="token" :trigger="['click']">
      <a class="ant-dropdown-link" href="#" style="color: white">
        <m-icon type="icon-person-outline" /> {{ user.accountDisplayName }}
      </a>
      <a-menu slot="overlay">
        <a-menu-item>
          <a @click="handleHomePage">
            <m-icon type="icon-home-outline"/>
            <span>返回主页</span>
          </a>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item>
          <a @click="handleLogout">
            <m-icon type="icon-log-out-outline"/>
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { getToken, removeToken, redirectToHomePage, redirectToLogin } from 'minerva-ui-sdk'
import { getUserInfo } from '@/services'

export default {
  name: 'header-bar',
  data () {
    return {
      user: {
        accountDisplayName: ''
      }
    }
  },
  async mounted () {
    const token = getToken()
    if (token) {
      const response = await getUserInfo()
      this.user = response.data
    }
  },
  computed: {
    token () { return getToken() }
  },
  methods: {
    handleHomePage () {
      if (process.env.VUE_APP_TENANT === 'pwc') {
        redirectToLogin()
      } else {
        redirectToHomePage()
      }
    },
    handleLogout () {
      removeToken()
      window.location.reload()
    },
    handleNaviagteApp (app) {
      const url = getAppUrl(app)
      if (url) window.location.href = url
    }
  }
}
</script>
